// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2YfJU","inputWrap":"styles_inputWrap__3oKf5","input":"styles_input__1N85w"};